module.exports = __webpack_public_path__ + "img/category-casino.d1157bf2.png";